import { IDropdownOption, List } from "@fluentui/react";
import React from "react";
import { Utils } from "../../../common/views/Utils";
import { NewLineModel, NewProductModel } from "../../models/NewProductModel";
import DisplayLineView from "./DisplayLineView";
import ProductInputView from "./ProductInputView";

export type ProductInputListProps = {
    lines: NewLineModel[];
    sizeOptions: IDropdownOption[];
    onValueChange: <K extends keyof NewProductModel>(
        lineIndex: number, productIndex: number, field: K, value: NewProductModel[K]
    ) => void;
}

export default function ProductInputListView({ lines, sizeOptions, onValueChange }: ProductInputListProps) {
    const width4 = Utils.getColumnWidth(4);
    const width8 = Utils.getColumnWidth(8);

    const productHeader = () => {
        const className1 = Utils.getColumnWidth(1);
        const className3 = Utils.getColumnWidth(3);

        return <div className="ms-Grid-row pb-5 font-bold">
            <div className={className3}>Size / Code</div>
            <div className={className3}>Barcode</div>
            <div className={className1}>Msrp $</div>
            <div className={className1}>Price $</div>
            <div className={className1}>Ship $</div>
            <div className={className1}>Fee $</div>
            <div className={className1 + " right"}>Total $</div>
        </div>;
    }

    const onRenderCell = (item?: NewProductModel, index?: number, lineIndex?: number) => {
        if (!item) return <></>;

        return <div className="pb-5">
            <ProductInputView
                form={item}
                lineIndex={lineIndex ?? 0}
                productIndex={index ?? 0}
                sizeOptions={sizeOptions}
                onValueChange={onValueChange}
            />
        </div>;
    }

    return <>
        {lines.map((line: NewLineModel, lineIndex: number) => {
            return <div className="ms-Grid-row border-bottom pv-10">
                <div className={width4}>
                    <DisplayLineView line={line} />
                </div>
                <div className={width8}>
                    {productHeader()}

                    <List
                        items={line.products}
                        onRenderCell={(item?: NewProductModel, index?: number) =>
                            onRenderCell(item, index, lineIndex)}
                    />
                </div>
            </div>;
        })}
    </>;
}